import { HallWagerData } from "../interfaces";

export function hallWagerToHallWagerData(wager: HallWager): HallWagerData {
    return {
        first_payment_percent: wager.first_payment_percent,
        first_payment_bonus: wager.first_payment_bonus,
        second_payment_percent: wager.second_payment_percent,
        second_payment_bonus: wager.second_payment_bonus,
        third_payment_percent: wager.third_payment_percent,
        third_payment_bonus: wager.third_payment_bonus,
        fortune_wheel: { ...wager.fortune_wheel },
        referral: { ...wager.referral },
    }
}

export function getDefaultHallWagerData(): HallWagerData {
    return {
        first_payment_percent: 0,
        first_payment_bonus: 0,
        second_payment_percent: 0,
        second_payment_bonus: 0,
        third_payment_percent: 0,
        third_payment_bonus: 0,
        fortune_wheel: {
            period: 0,
            minDeposit: 0,
            wager: 0,
        },
        referral: {
            percent: 0,
            period: 0,
            wager: 0,
        },
    }
}